export const getEmptyCustomLicense = (orgCode) => {

  const apiResponse = `
{
  "Price": 0,
  "Description": "Enterprise",
  "Number Of Assets": 0,
  "Scan Frequency": "Every 1 Hours",
  "Support Response": "Within 1 hrs",
  "Add ons": [
    {
      "Name": "Event Insight",
      "Price": 0,
      "Description": "Event Insight"
    },
    {
      "Name": "Cost Insight",
      "Price": 0,
      "Description": "Cost Insight"
    },
    {
      "Name": "Cost Optimization",
      "Price": 0,
      "Description": "Cost Insight"
    }
  ],
  "Compliance Add Ons": [
    {
      "Name": "CSA",
      "Price": 0,
      "Description": "CSA CCM v4.02"
    },
    {
      "Name": "MITRE",
      "Price": 0,
      "Description": "MITRE ATT&CK Cloud, MITRE ATT&CK Containers"
    },
    {
      "Name": "HITRUST",
      "Price": 0,
      "Description": "HITRUST CSF 11.2"
    },
	  {
      "Name": "CCPA",
      "Price": 0,
      "Description": "CCPA"
    },
	  {
      "Name": "NIST",
      "Price": 0,
      "Description": "NIST SP 800-171, NIST SP 800-53, NIST CSF v1.1"
    },
	  {
      "Name": "HIPAA",
      "Price": 0,
      "Description": "US HIPAA 164"
    },
	  {
      "Name": "CIS",
      "Price": 0,
      "Description": "CIS Benchmark v2.0.0"
    },
	  {
      "Name": "AWS",
      "Price": 0,
      "Description": "AWS Well Architected Framework"
    },
	  {
      "Name": "SOC2",
      "Price": 0,
      "Description": "AICPA SOC 2"
    },
	  {
      "Name": "ISO",
      "Price": 0,
      "Description": "ISO 27001"
    },
	  {
      "Name": "GDPR",
      "Price": 0,
      "Description": "EU GDPR 2016/679"
    },
	  {
      "Name": "PCI",
      "Price": 0,
      "Description": "PCI DSS v4.0"
    }
  ],
  "orgCode": "${orgCode}"
}
`;
  return JSON.parse(apiResponse);
}
